import { accountRoutes, adminRoutes, districtRoutes } from '../common/routes';
export const NotificationType = {
    ClaimApproved: 'claim-approved',
    ClaimDenied: 'claim-denied',
    ClaimSubmitted: 'claim-submitted',
    PropertyEditApproved: 'property-edit-approved',
    PropertyEditDenied: 'property-edit-denied',
    PropertyEditSubmitted: 'property-edit-submitted',
    ChangeRequestSubmitted: 'change-request-submitted',
    ChangeRequestApproved: 'change-request-approved',
    ChangeRequestDenied: 'change-request-denied',
    DiscussionAccessGranted: 'discussion-access-granted',
    DiscussionAccessRequest: 'discussion-access-request',
    RoleUpdated: 'role-updated',
    DiscussionReaction: 'discussion-reaction',
    CommentReaction: 'comment-reaction',
    DiscussionComment: 'discussion-comment',
    CommentReply: 'comment-reply',
    ContentFlagged: 'content-flagged',
    AccountCreated: 'account-created',
    TourAlert: 'tour-alert',
};
export const NOTIFICATION_ICONS = {
    [NotificationType.ClaimApproved]: 'bi-check-circle text-success',
    [NotificationType.ClaimDenied]: 'bi-x-circle text-danger',
    [NotificationType.ClaimSubmitted]: 'bi-file-earmark-plus text-primary',
    [NotificationType.PropertyEditApproved]: 'bi-check-circle text-success',
    [NotificationType.PropertyEditDenied]: 'bi-x-circle text-danger',
    [NotificationType.PropertyEditSubmitted]: 'bi-pencil-square text-primary',
    [NotificationType.ChangeRequestSubmitted]: 'bi-file-earmark-plus text-primary',
    [NotificationType.ChangeRequestApproved]: 'bi-file-earmark-check text-success',
    [NotificationType.ChangeRequestDenied]: 'bi-file-earmark-x text-danger',
    [NotificationType.DiscussionAccessGranted]: 'bi-chat-dots text-success',
    [NotificationType.DiscussionAccessRequest]: 'bi-chat-left-text text-primary',
    [NotificationType.RoleUpdated]: 'bi-shield-check text-info',
    [NotificationType.DiscussionReaction]: 'bi-emoji-smile text-warning',
    [NotificationType.CommentReaction]: 'bi-emoji-smile text-warning',
    [NotificationType.DiscussionComment]: 'bi-chat-dots text-primary',
    [NotificationType.CommentReply]: 'bi-reply text-primary',
    [NotificationType.ContentFlagged]: 'bi-flag text-danger',
    [NotificationType.AccountCreated]: 'bi-person-check text-success',
    [NotificationType.TourAlert]: 'bi-bell text-primary',
};
/** Centralized mapping from notification type → URL. Returns null if no navigation target. */
export function getNotificationURL(n) {
    const ref = n.referenceId;
    switch (n.notificationType) {
        // Claims, property-edit approvals and change requests are all retired. Notifications of these
        // types are still in people's lists, so they keep their entry here; the screens that used to
        // action them are gone, so the ones that pointed at a review queue no longer link anywhere.
        case NotificationType.ClaimApproved:
        case NotificationType.ClaimDenied:
        case NotificationType.PropertyEditApproved:
        case NotificationType.PropertyEditDenied:
        case NotificationType.ChangeRequestApproved:
        case NotificationType.ChangeRequestDenied:
            return accountRoutes.account.getURL({ tab: 'my-properties' });
        case NotificationType.ClaimSubmitted:
        case NotificationType.ChangeRequestSubmitted:
            return null;
        // Still sent: somebody contributed to a property in the community.
        case NotificationType.PropertyEditSubmitted:
            return ref ? accountRoutes.myPropertiesManage.getURL({ id: ref }) : null;
        case NotificationType.DiscussionAccessGranted:
            return districtRoutes.discussions.getURL();
        case NotificationType.DiscussionAccessRequest:
            return ref ? adminRoutes.peopleDetail.getURL({ id: ref }) : adminRoutes.people.getURL();
        case NotificationType.RoleUpdated:
            return null;
        case NotificationType.DiscussionReaction:
        case NotificationType.DiscussionComment:
        case NotificationType.CommentReply:
        case NotificationType.ContentFlagged:
            return ref ? districtRoutes.discussionsDetail.getURL({ id: ref }) : districtRoutes.discussions.getURL();
        case NotificationType.CommentReaction:
            return null;
        case NotificationType.TourAlert:
            return ref ? districtRoutes.toursDetail.getURL({ id: ref }) : districtRoutes.tours.getURL();
        default:
            return null;
    }
}
